import type { JSX } from 'react';
import { TabbedSection } from '@/components/layout/TabbedSection';
import { PageHeader } from '@/components/ui/page-header';
import { CronRunsPanel } from '@/components/invites/CronRunsButton';
import { AdminTeams } from './AdminTeams';
import { AdminTeamSettings } from './AdminTeamSettings';
import { AdminRates } from './AdminRates';
import { AdminBrackets } from './AdminBrackets';
import { AdminCategories } from './AdminCategories';
import { AdminProviders } from './AdminProviders';

/** Setup → Teams: the teams themselves, and the rules each one runs under. */
export function AdminSetupTeams(): JSX.Element {
  return (
    <TabbedSection
      title="Teams"
      tabs={[
        { id: 'teams', label: 'Teams', element: <AdminTeams /> },
        { id: 'rules', label: 'Rules', element: <AdminTeamSettings /> },
      ]}
    />
  );
}

/** Setup → Compensation: what an invite earns, in one place. */
export function AdminSetupCompensation(): JSX.Element {
  return (
    <TabbedSection
      title="Compensation"
      tabs={[
        { id: 'rates', label: 'Rates', element: <AdminRates /> },
        { id: 'follower-bonuses', label: 'Follower bonuses', element: <AdminBrackets /> },
        { id: 'creator-types', label: 'Creator types', element: <AdminCategories /> },
      ]}
    />
  );
}

/** Setup → System: scheduled jobs and payout providers. */
export function AdminSystem(): JSX.Element {
  return (
    <TabbedSection
      title="System"
      tabs={[
        {
          id: 'jobs',
          label: 'Scheduled jobs',
          element: (
            <div className="space-y-6">
              <PageHeader
                title="Scheduled jobs"
                description="What runs automatically, when it last ran, and what happened. Jobs that move money ask before running."
              />
              <CronRunsPanel />
            </div>
          ),
        },
        { id: 'providers', label: 'Payout providers', element: <AdminProviders /> },
      ]}
    />
  );
}
